import moment from "moment";
import { useAppSelector } from "../../config/hooks";

const useEmployeeTimesheet = () => {
  const timesheet = useAppSelector((state) => state.attendance.timesheet);
  const weeklyTimesheet = useAppSelector(
    (state) => state.attendance.weeklyTimesheet
  );
  const holidayList = useAppSelector((state) => state.appConfig.holidayList);
  const employeeWorking = (date) => {
    let working = timesheet?.find(
      (t) => moment(t.date).format("YYYY/MM/DD") == date
    );
    return working;
  };
  const getHoliday = (date) => {
    let holiday = holidayList?.find(
      (h) => moment(h.Date).format("YYYY/MM/DD") == date
    );
    return holiday;
  };

  const checkWeekSubmit = (startDate, endDate) => {
    let weekSubmited = weeklyTimesheet?.filter(
      (sheet) =>
        moment.utc(sheet.weekStartDate).format("DD/MM/YYYY") == startDate &&
        moment.utc(sheet.weekEndDate).format("DD/MM/YYYY") == endDate
    );
    return weekSubmited;
  };
  return { getHoliday, employeeWorking, checkWeekSubmit };
};
//"Date": "2025-02-26",

export default useEmployeeTimesheet;
